import styled from 'styled-components';
import ButtonLogic from './ButtonLogic';

export default styled(ButtonLogic)`
   -webkit-appearance: none;
   border: none;
   background: none;
   cursor: pointer;
`;
